export default __webpack_public_path__ + "static/media/fusion_pool_article.274deb1d.png";